import { getAuthToken } from './authToken';

export const API = {
    async json(url, { method='GET', headers={}, body=null, raw=false } = {}) {
        const token = getAuthToken();

        const opts = {
            method,
            headers: { 'Content-Type': 'application/json', ...headers },
            credentials: 'include',
        };
        if (token) opts.headers['Authorization'] = `Bearer ${token}`;
        if (body && !(body instanceof FormData)) opts.body = JSON.stringify(body);
        if (body instanceof FormData) { delete opts.headers['Content-Type']; opts.body = body; }

        const res = await fetch(url, opts);
        if (raw) return res;
        let data = null; try { data = await res.json(); } catch {}
        if (!res.ok) throw new Error(data?.blad || `HTTP ${res.status}`);
        return data;

    },

    async raw(url, { method='GET', headers={}, body=null } = {}) {
        const token = getAuthToken();
        const opts = { method, headers: { ...headers }, credentials:'include' };
        if (token) opts.headers['Authorization'] = `Bearer ${token}`;
        if (body) opts.body = body;
        return fetch(url, opts); // zwraca Response (np. do blob())
    },
    // Exams
    preflight:   (attemptId, st) => API.json(`/api/exam/attempts/${attemptId}/session/preflight`, { method:'POST', body:{ st } }),
    serverTime:  () => API.json(`/api/exam/time`),
    getStartUrl: (attemptId) => API.json(`/api/exam/attempts/${attemptId}/start-url`),
    getSebFile: (attemptId) => API.raw(`/api/exam/attempts/${attemptId}/seb-file`),
    sebCheck: () => API.json('/api/seb/check'),
    getSession:  (attemptId) => API.json(`/api/exam/attempts/${attemptId}/session`, { method:'POST' }),
    enterSession:(attemptId, payload) => API.json(`/api/exam/attempts/${attemptId}/session/enter`, { method:'POST', body: payload }),
    pack:        (attemptId) => API.json(`/api/exam/attempts/${attemptId}/pack`, { method:'POST' }),
    kvsEnsure:   (attemptId, clientStartMs) => API.json(`/api/exam/attempts/${attemptId}/kvs/ensure`, { method:'POST', body:{ clientStartMs }}),
    answersBulk: (attemptId, payload) => API.json(`/api/exam/attempts/${attemptId}/answers/bulk`, { method:'POST', body: payload }),
    ansFileInit: (attemptId, qid, meta) => API.json(`/api/exam/attempts/${attemptId}/answers/${qid}/file/initiate`, { method:'POST', body: meta }),
    ansFileFin:  (attemptId, qid, meta) => API.json(`/api/exam/attempts/${attemptId}/answers/${qid}/file/finalize`, { method:'POST', body: meta }),
    finish:      (attemptId, payload) => API.json(`/api/exam/attempts/${attemptId}/finish`, { method:'POST', body: payload }),

    // Verify
    verifyInit:  (attemptId, fileMeta) => API.json(`/api/exam/attempts/${attemptId}/verify/initiate-photo`, { method:'POST', body: fileMeta }),
    verifyAuto:  (attemptId, selfie_key) => API.json(`/api/exam/attempts/${attemptId}/verify/auto`, { method:'POST', body: { selfie_key } }),
    verifyManual:(attemptId, selfie_key) => API.json(`/api/exam/attempts/${attemptId}/verify/manual`, { method:'POST', body: { selfie_key, consent:true } }),


    // tworzy (albo zwraca istniejący) attempt dla danego terminu
    initiateAttempt: (termId) =>  API.json(`/api/exam/terms/${termId}/attempts/initiate`, { method: 'POST' }),

    // krótkotrwały token do poczekalni

    proctorFlag: (attemptId, payload) =>
        API.json(`/api/exam/attempts/${attemptId}/flags`, { method:'POST', body: payload }),

    // (opcjonalnie – jeśli później dodasz endpoint /kvs/creds)
    kvsCreds: (attemptId) => API.json(`/api/exam/attempts/${attemptId}/kvs/creds`, { method:'POST' }),





};
